import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { getFormById, getFormByIdWithoutAuthen } from '@/service/formManagementService';
import { getTicketById } from '@/service/ticketService';

export const buildAutoFillTagField = async (argsCommon) => {
    let tagField = argsCommon.tagField;
    const isNotAuthen = argsCommon?.isNotAuthen;
   const listItem = tagField.structure.listItem
    try {
        const firstItem = listItem[0];
        const typeOfItem = Utils.getPrefixOfId(firstItem.itemId);
        if (typeOfItem === 'tag') {
            const listActiveItem = listItem.filter((item) => item.isActive === true);
            let promiseAll = [];
            if(!Utils.isEmptyArray(listActiveItem)){
            listActiveItem.forEach((item) => {
                promiseAll.push(isNotAuthen ? getFormByIdWithoutAuthen(argsCommon?.API, item.itemId) :getFormById(argsCommon?.API, item.itemId));
            });
            const listItemDetail = await Promise.all(promiseAll);
            let tagItemList = [];
            let itemSelectedList = [];
            for (const field of listItemDetail) {
                const currentItem = listItem.find((item) => item.itemId === field.item);
                const itemData = {
                    title: Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, field.name),
                    value: field.id,
                    no: Utils.isEmpty(currentItem) ? 1 : currentItem.order,
                    hitNumber: Utils.isEmpty(currentItem) ? 0 : currentItem.hitNumber,
                };
                tagItemList.push(itemData);
                if (
                    !Utils.isEmptyArray(argsCommon.defaultValue) &&
                    argsCommon.defaultValue.includes(field.id)
                ) {
                    itemSelectedList.push(itemData);
                }
            }
            argsCommon.setTagList(tagItemList);
            argsCommon.setOriginItemList(tagItemList);
            argsCommon.setTagValue(itemSelectedList);
        }}else{
            const listActiveItem = listItem.filter((item) => item.isActive === true);
            let promiseAll = [];
            if(!Utils.isEmptyArray(listActiveItem)){
            listActiveItem.forEach((item) => {
                promiseAll.push(getTicketById(argsCommon?.API, item.itemId));
            });
            const listItemDetail = await Promise.all(promiseAll);
            let tagItemList = [];
            let itemSelectedList = [];
            for (const field of listItemDetail) {
                const currentItem = listItem.find((item) => item.itemId === field.item);
                const itemData = {
                    title: Utils.convertJSONDataToObject(field.outline).jp,
                    value: field.id,
                    no: Utils.isEmpty(currentItem) ? 1 : currentItem.order,
                    hitNumber: Utils.isEmpty(currentItem) ? 0 : currentItem.hitNumber,
                };
                tagItemList.push(itemData);
                if (
                    !Utils.isEmptyArray(argsCommon.defaultValue) &&
                    argsCommon.defaultValue.includes(field.id)
                ) {
                    itemSelectedList.push(itemData);
                }
            }
            argsCommon.setTagList(tagItemList);
            argsCommon.setOriginItemList(tagItemList);
            argsCommon.setTagValue(itemSelectedList);
        }
        }
    } catch (error) {
        console.log('buildItemTagList get ticket outline error: ', error);
        argsCommon.setTagList([]);
        argsCommon.setTagValue([]);
    }
};
